import { AdvancedPlansFeature } from 'types';
import { Language } from 'enums';

export function filterFeaturesByLanguage(
  features: AdvancedPlansFeature[],
  userLanguage: Language,
): AdvancedPlansFeature[] {
  return features.filter((feature) => {
    if (feature.includedInLangs?.length && feature.excludedInLangs?.length) {
      throw new Error(
        `Feature ${feature.translationKey} was defined to be both excluded and included in specific languages`,
      );
    }
    if (feature.includedInLangs?.length) {
      return feature.includedInLangs.includes(userLanguage);
    }
    if (feature.excludedInLangs?.length) {
      return !feature.excludedInLangs.includes(userLanguage);
    }
    return true;
  });
}
